<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2"><i>Foreword by Ed Stetzer</i></a></div>
<div class="SOM_pre"><a href="#/pre3"><b>1</b> Introduction: The Challenge Congregations Face in America</a></div>
<div class="SOM_part"><a href="#/p1"><span class="mev1">Part 1</span> Recovering a Missional Imagination for the Unchurched in America</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><b>2</b> Exposing Common Myths About Unchurched Americans</a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample"><b>3</b> Embracing a New Narrative About the Unchurched</span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><b>4</b> Engaging the Receptive Millennials, Nones, and Nominals in Your Life</span></div>
<div class="SOM_chap"><span href="#/p1chap4" title="Link target outside of Sample"><b>5</b> Exploring the Conversion Community Equation</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample"><span class="mev1">Part 2</span> Developing Missional Leaders</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><b>6</b> Modeling Outreach Others Can Imitate</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><b>7</b> Multiplying Missional Leaders</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample"><span class="mev1">Part 3</span> Cultivating a Missional Congregation</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><b>8</b> Belonging to the Broader Community</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><b>9</b> Blessing the World to Reach the World</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><b>10</b> Bringing the Community to Church</span></div>
<div class="SOM_chap"><span href="#/p3chap4" title="Link target outside of Sample"><b>11</b> Building a Community of the Beloved Through Hospitality</span></div>
<div class="SOM_chap"><span href="#/p3chap5" title="Link target outside of Sample"><b>12</b> Conclusion: From a Conversion Community to a Conversion Movement</span></div>
<div class="SOM_appen_autre"><span href="#/appen4" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Billy Graham Center Resources</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Contributing Research Projects</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>You Found Me</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?e0f6427e